import { useIsFetching } from "@tanstack/react-query"

import { SPEEDINGS_ROOT_QUERY_KEY } from "./queryKeys"

export function useIsFetchingSpeedings() {
    const isFetchingSpeedings = useIsFetching({ queryKey: [SPEEDINGS_ROOT_QUERY_KEY, "layer"] })

    return isFetchingSpeedings > 0
}